var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlash1StreamlineFlex1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.04477 12.4703C4.19188 9.47297 4.75697 5.53547 6.2059 2.65714C6.41791 2.23595 6.82358 1.95339 7.29106 1.89574C8.21073 1.78233 9.7828 1.65573 11.8666 1.65573C13.3978 1.65573 14.7453 1.77341 15.7782 1.9133C16.7737 2.04815 17.2948 3.0866 16.8997 4.01162L15.2444 7.88765C16.6947 7.94189 17.8198 8.05869 18.8688 8.2791C19.7819 8.47099 20.2361 9.44905 19.7744 10.2611C18.1165 13.1774 14.3074 17.8896 8.80338 22.1732C8.27033 22.588 7.5131 22.2008 7.5557 21.526C7.71666 18.9772 8.26484 16.9086 9.11707 14.1229H5.65412C4.7422 14.1229 4 13.3824 4.04477 12.4703Z",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash1StreamlineFlex1);
export default __webpack_public_path__ + "static/media/Flash-1--Streamline-Flex 1.9157906f238274a77fa2dba73de1e267.svg";
export { ForwardRef as ReactComponent };